import React, {useCallback, useState} from "react";
import moment from "moment";
import {AutocompleteInput, ReferenceInput, required, Title} from "react-admin";
import {TreeCheckboxInputV2} from "../../components/TreeCheckboxInputV2";
import {ReportForm, schoolYears, showErrorNotify} from "../../components";
import {downloadFilePost} from "../../components/FileDownload";
import env from "../../env";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import {MonthInput} from "../../components/MonthInput";

const PostedBillBatch = (props) => {

    const [changeSchoolYear, setChangeSchoolYear] = useState(false);
    const [loading, setLoading] = useState(false);

    const [payload, setPayload] = useState({
        fromMonth: moment().format("YYYY-MM"),
        toMonth: moment().format("YYYY-MM"),
        unitIds: [],
        productIds: [],
        schoolYearId: schoolYears[0].id,
    });

    /* ================= EXPORT EXCEL ================= */
    const excelReport = useCallback(() => {
        if (!payload.productIds?.length) {
            showErrorNotify("Vui lòng chọn danh sách phí");
            return;
        }
        if (!payload.unitIds?.length) {
            showErrorNotify("Vui lòng chọn danh sách lớp");
            return;
        }

        const data = {
            fromMonth: payload.fromMonth,
            toMonth: payload.toMonth,
            unitIds: payload.unitIds,
            schoolYearId: payload.schoolYearId,
            productIds: payload.productIds,
        };

        setLoading(true);
        downloadFilePost(
            `${env.reportURL}/reports/posted-bill-batch`,
            "bang_ke_danh_muc_theo_hs.xlsx",
            data
        ).finally(() => setLoading(false));
    }, [payload]);

    /* ================= VALIDATE ================= */
    const validate = useCallback((values) => {
        const errors = {};
        const {fromMonth, toMonth} = values;

        if (fromMonth && toMonth && fromMonth > toMonth) {
            errors.toMonth = "Thời gian không hợp lệ";
        }

        if (changeSchoolYear) {
            setChangeSchoolYear(false);
            setPayload({
                ...values,
                unitIds: [],
            });
        } else {
            setPayload(values);
        }

        return errors;
    }, [changeSchoolYear]);

    /* ================= SCHOOL YEAR CHANGE ================= */
    const onSchoolYearChanged = (event, value) => {
        setPayload(prev => ({
            ...prev,
            schoolYearId: value
        }));
        setChangeSchoolYear(true);
    };

    return (
        <React.Fragment>
            <Card>
                <Title title="resources.posted-bill-batch.name"/>
                <CardContent>
                    <ReportForm
                        params={payload}
                        validate={validate}
                        excelReport={excelReport}
                        isLoading={loading}
                    >
                    <span>
                        Dữ liệu hiển thị theo kế hoạch thu từ tháng đến tháng, trong đó thông tin lớp học được lưu trữ theo kế hoạch thu của học sinh tại từng thời điểm. Khi học sinh chuyển lớp, để xem đầy đủ dữ liệu của học sinh đó, bạn cần chọn lớp hiện tại của học sinh thay vì lớp cũ.
                    </span>
                        {/* ===== DATE ===== */}
                        <Grid container spacing={8} style={{marginTop: 16}}>
                            <Grid item xs={12} sm={3}>
                                <MonthInput
                                    label="Từ tháng"
                                    source="fromMonth"
                                    validate={required()}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <MonthInput
                                    label="Đến tháng"
                                    source="toMonth"
                                    validate={required()}
                                />
                            </Grid>
                            <Grid item xs={12} sm={1}>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <ReferenceInput
                                    source="schoolYearId"
                                    reference="schoolYears"
                                    label="resources.schoolYears.name"
                                    perPage={50}
                                    validate={required()}
                                    onChange={onSchoolYearChanged}
                                    {...props}
                                >
                                    <AutocompleteInput optionText="name"/>
                                </ReferenceInput>
                            </Grid>
                        </Grid>


                        {/* ===== SCHOOL YEAR + CLASS ===== */}
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <label>Khoản thu *</label>
                                <div style={{maxHeight: 500, overflow: "auto"}}>
                                    <ReferenceInput
                                        source="productIds"
                                        reference="billProducts"
                                        perPage={999}
                                        {...props}
                                    >
                                        <TreeCheckboxInputV2
                                            labelRender={item => `${item.id} - ${item.name}`}
                                            optionValue="id"
                                            optionText="name"
                                            expandTopLevel
                                            optionDeleteProp={'enable'}
                                            hideDeleted={true}
                                        />
                                    </ReferenceInput>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={1}>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <label>Danh sách lớp *</label>
                                <div style={{maxHeight: 500, overflow: "auto"}}>
                                    <ReferenceInput
                                        source="unitIds"
                                        reference="units"
                                        perPage={999}
                                        filter={{
                                            clazzWithParents: true,
                                            schoolYear: payload.schoolYearId
                                        }}
                                        {...props}
                                    >
                                        <TreeCheckboxInputV2
                                            labelRender={item => `${item.id} - ${item.name}`}
                                            optionValue="id"
                                            optionText="name"
                                            expandTopLevel
                                            hideDeleted={false}
                                        />
                                    </ReferenceInput>
                                </div>
                            </Grid>

                        </Grid>
                    </ReportForm>
                </CardContent>
            </Card>
        </React.Fragment>
    );
};

export default PostedBillBatch;
